import { render, staticRenderFns } from "./FeeRatioSetup.vue?vue&type=template&id=71de231a&scoped=true"
import script from "./FeeRatioSetup.vue?vue&type=script&lang=js"
export * from "./FeeRatioSetup.vue?vue&type=script&lang=js"
import style0 from "./FeeRatioSetup.vue?vue&type=style&index=0&id=71de231a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71de231a",
  null
  
)

export default component.exports